export enum UserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  COMPANY_OWNER = 'COMPANY_OWNER',
  MANAGER = 'MANAGER',
  ACCOUNTANT = 'ACCOUNTANT',
  MEMBER = 'MEMBER'
}

export interface User {
  id?: string;
  uid: string;
  name: string;
  email: string;
  phoneNumber?: string | null;
  profileImage?: string | null;
  isEmailVerified: boolean;
  isActive: boolean;
  signUpMethod: 'email-password' | 'google' | 'facebook' | 'admin-created';
  role?: UserRole | 'super-admin' | 'company-admin' | 'manager' | 'staff' | 'auditor';
  companyId?: string;
  companyRole?: string; // Role within the company
  lastLoginAt?: Date | null;
  __system?: import('../utils/system-metadata.util').SystemMetadata;
}

export interface AuthUser {
  uid: string;
  email: string | null;
  displayName: string | null;
  phoneNumber: string | null;
  isAdmin?: boolean;
  customClaims?: {
    isAdmin?: boolean;
    role?: string;
    companyId?: string;
  };
}

